export default __webpack_public_path__ + "img/e495e207dd92f45657788add5f353c44.png";